"use client";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AboutHeroSection from "@/components/AboutHeroSection";
import mobileDevelopment from "../../public/assets/images/services/mobile-app-development/mobile-app-development-png.png";
import Image from "next/image";
import {
  mobileAppServices,
  mobileAppTechnologies,
  mobileAppTimeLine,
} from "../../utils/libs/utils";
const ServiceBox = ({ title, description, points }) => (
  <div className="service-inner-box w-100 ">
    <h3>{title}</h3>
    <p>{description}</p>
    <ul>
      {points.map((point, index) => (
        <li key={index}>{point}</li>
      ))}
    </ul>
  </div>
);

const MobileApp = () => {
  useEffect(() => {
    const reveal = () => {
      document.querySelectorAll(".reveal").forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        const elementVisible = 10;

        if (
          elementTop < windowHeight - elementVisible &&
          !el.classList.contains("active")
        ) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal(); // run on load

    return () => window.removeEventListener("scroll", reveal);
  }, []);

  return (
    <div>
      <AboutHeroSection
        pillText="~ Our Tech Stack ~"
        title="Mobile App Development Services with"
        highlight="Neoverce"
        description="At Neoverce, we take a personalized, results-driven approach to app development, ensuring that your mobile app is designed with your specific business objectives in mind. With a team of skilled developers, designers, and strategists, we build innovative mobile applications that enhance user engagement, streamline business processes, and boost your digital presence."
        imageAlt="Mobile App Development Services"
        image={mobileDevelopment}
      />
      <div className="py-5">
        <Container>
          <Row className="justify-content-center gy-4">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Comprehensive Mobile App <span>Development Services</span>
              </h3>
              <p className="reveal fade-bottom">
                With our extensive experience and technical expertise, Neoverce
                is your ideal partner for all your mobile app development needs.
                Whether you're building a simple app or a sophisticated
                platform, we ensure your project is completed on time, within
                budget, and to the highest standards.
              </p>
            </Col>

            {mobileAppServices.map((service, idx) => (
              <Col
                md={6}
                sm={12}
                key={idx}
                className="d-flex reveal fade-bottom"
              >
                <ServiceBox {...service} />
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="service-section-bg my-5">
        <Container>
          <Row className="gy-4 justify-content-center">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Building Apps with <span>Advanced Mobile Technologies</span>
              </h3>
              <p className="reveal fade-bottom">
                We leverage the latest tools and frameworks to build powerful,
                high-performing mobile apps that meet modern user expectations.
                We used cross-platform development frameworks like React Native
                and Flutter, along with robust security protocols, to deliver
                scalable, secure, and future-ready mobile solutions.
              </p>
            </Col>

            {mobileAppTechnologies.map((tech, index) => (
              <Col
                key={index}
                lg={2}
                md={3}
                sm={4}
                xs={6}
                className="reveal fade-bottom d-flex"
              >
                <div className="tech-image-box text-center">
                  <Image
                    height={100}
                    width={100}
                    alt={tech.alt}
                    src={tech.src}
                    className="img-fluid"
                  />
                  <h3>{tech.name}</h3>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="mt-5 py-5">
        <Container>
          <Row>
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Our Proven Mobile <span>App Development Process</span>
              </h3>
              <p className="reveal fade-bottom">
                We follow a structured yet flexible mobile app development
                process designed to ensure your app is built to perfection. Our
                approach is centered around collaboration, innovation, and
                quality. Here’s how we do it.
              </p>
            </Col>
          </Row>
          <div className="py-5">
            <Row className="timeline zipzap gx-0 position-relative">
              {mobileAppTimeLine.map((step, i) => {
                const isFirst = i === 0;
                const isLast = i === mobileAppTimeLine.length - 1;

                const timelineRowClass =
                  `timeline-row d-flex align-items-center pb-5 position-relative 
            ${isFirst ? "first-timeline" : ""} 
            ${isLast ? "last-timeline" : ""}`.trim();

                return (
                  <Col key={i} md={12} className={timelineRowClass}>
                    {i % 2 === 0 ? (
                      <>
                        <Col
                          md={6}
                          className="d-flex justify-content-center even-section align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="timeline-box text-box ms-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={6} className="text-md-end">
                          <div className="timeline-box text-box me-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                        <Col
                          md={6}
                          className="d-flex justify-content-center align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                  </Col>
                );
              })}
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default MobileApp;
